// @ts-nocheck
import * as React from "react";

const HeartFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m12 21.004-.758-.685a136.133 136.133 0 0 1-4.05-3.828c-1.068-1.062-1.91-1.998-2.529-2.81-.618-.81-1.05-1.544-1.295-2.2A5.617 5.617 0 0 1 3 9.5c0-1.272.432-2.34 1.296-3.204C5.16 5.432 6.228 5 7.5 5c.88 0 1.704.225 2.475.675.77.45 1.446 1.104 2.025 1.963.58-.859 1.255-1.513 2.025-1.963A4.827 4.827 0 0 1 16.5 5c1.272 0 2.34.432 3.204 1.296C20.568 7.16 21 8.228 21 9.5c0 .664-.123 1.324-.368 1.98-.246.657-.678 1.39-1.296 2.202-.617.81-1.457 1.747-2.519 2.809a117.172 117.172 0 0 1-4.06 3.828l-.757.685Zm0-1.354c1.6-1.446 2.917-2.685 3.95-3.716 1.033-1.032 1.85-1.927 2.45-2.685.6-.758 1.017-1.43 1.25-2.015.233-.586.35-1.164.35-1.734 0-1-.333-1.833-1-2.5s-1.5-1-2.5-1c-.796 0-1.53.227-2.204.682-.673.454-1.275 1.138-1.807 2.053h-.978c-.544-.927-1.15-1.615-1.817-2.063A3.852 3.852 0 0 0 7.5 6c-.987 0-1.817.333-2.49 1C4.337 7.667 4 8.5 4 9.5c0 .57.117 1.148.35 1.734.233.585.65 1.257 1.25 2.015.6.758 1.417 1.65 2.45 2.675A133.115 133.115 0 0 0 12 19.65Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(HeartFill);
